fragment PrintAssignmentFragment on PrintAssignment {

    id

    created_at
    updated_at

    media {
        ...MediaFragment
    }

    printTechnique {
        ...PrintTechniqueFragment
    }

    printCosts(orderBy: [{ column: "color", order: ASC }]) {
        ...PrintCostFragment
    }

    printHandlingCharge {
        ...PrintHandlingChargeFragment
    }

    media_id
    print_handling_charge_id

    location
    priority
    max_colors

    width
    height
    diameter

    supplier_id

}